import { render } from "./FooterLink.vue?vue&type=template&id=51eadb3b&scoped=true"
import script from "./FooterLink.vue?vue&type=script&lang=js"
export * from "./FooterLink.vue?vue&type=script&lang=js"

import "./FooterLink.vue?vue&type=style&index=0&id=51eadb3b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51eadb3b"]])

export default __exports__